let fetcher = async () => null;
/**
 * Register the fetcher at app boot. Admin wires its API client here before
 * the FlowEditor mounts; tests pass a stub.
 */
export function setFormItemInferenceFetcher(next) {
    fetcher = next;
}
export function inferFormItem(request) {
    return fetcher(request);
}
//# sourceMappingURL=formItemInference.js.map